module.exports = __webpack_public_path__ + "static/media/simulationattackimg.3e79fc5d.png";